import React from 'react';
import Layout from '../Layout';

const NotFound = () => {
    return (
        <Layout>


            <div className='w-100 h-100 d-flex justify-content-center align-items-center mt-5'>
                <h2>The Page not found</h2>
            </div>

        </Layout>
    );
};

export default NotFound;